<div class="navbar bg-base-100 shadow-sm">
  <div class="navbar-start">
    <!-- <a class="btn btn-ghost text-xl">{{ appName }}</a> -->
    @if (selectedTenant) {
    <!-- <div class="divider divider-horizontal mx-2"></div> -->
    <div class="flex items-center gap-2 px-2">
      @if (selectedTenant.logoBase64) {
      <div class="avatar">
        <div class="w-8 h-8 rounded">
          <img
            [src]="getLogoSrc(selectedTenant.logoBase64)"
            [alt]="selectedTenant.name"
            class="object-contain w-full h-full"
          />
        </div>
      </div>
      } @else {
      <div class="avatar placeholder">
        <div class="bg-primary text-primary-content w-8 h-8 rounded">
          <span class="text-xs">{{ selectedTenant.name.charAt(0).toUpperCase() }}</span>
        </div>
      </div>
      }
      <div class="flex flex-col">
        <span class="text-sm font-semibold">{{ selectedTenant.name }}</span>
        <span class="text-xs uppercase opacity-60">{{ selectedTenant.subdomain }}</span>
      </div>
    </div>
    }
  </div>

  <div class="navbar-center hidden lg:flex">
    <ul class="menu menu-horizontal px-1">
      @for (item of navLinks; track $index) { @if (!item.permission || item.permission()) { @if
      (!item.children) {
      <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <a [routerLink]="item.link">{{ item.label }}</a>
      </li>
      } @else {
      <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <details [open]="isChildActive(item)">
          <summary>{{ item.label }}</summary>
          <ul class="p-2">
            @for (child of item.children; track $index) { @if (!child.permission ||
            child.permission()) {
            <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              <a [routerLink]="child.link">{{ child.label }}</a>
            </li>
            } }
          </ul>
        </details>
      </li>
      } } }
    </ul>
  </div>

  <div class="navbar-end">
    <div class="dropdown dropdown-end">
      <div tabindex="0" role="button" class="btn btn-ghost btn-circle avatar">
        <div
          class="w-10 rounded-full bg-primary text-primary-content flex items-center justify-center"
        >
          @if (currentUser) {
          <span class="text-lg font-bold">{{ getUserInitials() }}</span>
          } @else {
          <span class="text-lg">?</span>
          }
        </div>
      </div>
      <ul
        tabindex="0"
        class="menu menu-sm dropdown-content bg-base-100 rounded-box z-1 mt-3 w-52 p-2 shadow"
      >
        @if (currentUser) {
        <li class="menu-title">
          <span>{{ currentUser.name }}</span>
          <span class="text-xs opacity-60">{{ currentUser.email }}</span>
        </li>
        <li class="menu-title">
          <span class="badge badge-sm badge-outline">{{ currentUser.type }}</span>
        </li>
        <div class="divider my-0"></div>
        } @for (option of userMenu; track $index) {
        <li>
          <a
            class="justify-between"
            [ngClass]="{ 'text-error': option.danger }"
            [routerLink]="option.link || null"
            (click)="option.action && option.action()"
          >
            {{ option.label }}
            @if (option.badge) {
            <span class="badge">{{ option.badge }}</span>
            }
          </a>
        </li>
        }
      </ul>
    </div>
  </div>
</div>
